var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-align-items-center is-flex-direction-row my-3"},[_c('div',{staticClass:"is-flex-grow-2 line"}),_c('div',{staticClass:"is-flex-shrink-0 has-text-centered px-4"},[_vm._t("default")],2),_c('div',{staticClass:"is-flex-grow-2 line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }